module.exports = __webpack_public_path__ + "static/img/enter2.7468185.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/enter2.jpg
// module id = cbGQ
// module chunks = 1